export default __webpack_public_path__ + "static/media/logo-auction.e6b9bfb3.png";